import { render } from "./MedicalTerminal.vue?vue&type=template&id=4334e2f2"
import script from "./MedicalTerminal.vue?vue&type=script&lang=js"
export * from "./MedicalTerminal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__